import * as Types from '../../../../gql/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type ShopByDepartmentItemFragment = (
  { __typename?: 'ShopByDepartment' }
  & Pick<Types.ShopByDepartment, 'title' | 'slug'>
  & { categoryLvl2Collection?: Types.Maybe<(
    { __typename?: 'ShopByDepartmentCategoryLvl2Collection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'SceneHierarchy' }
      & Pick<Types.SceneHierarchy, 'hirearchy' | 'label'>
    )>> }
  )>, thumbnail?: Types.Maybe<(
    { __typename?: 'ContentfullAsset' }
    & Pick<Types.ContentfullAsset, 'url' | 'title' | 'width' | 'height'>
  )> }
);

export type ShopByDepartmentCollectionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ShopByDepartmentCollectionQuery = (
  { __typename?: 'Query' }
  & { shopByDepartmentCollection?: Types.Maybe<(
    { __typename?: 'ShopByDepartmentCollection' }
    & { items: Array<Types.Maybe<(
      { __typename?: 'ShopByDepartment' }
      & ShopByDepartmentItemFragment
    )>> }
  )> }
);

export type ShopByDepartmentSitemapQueryVariables = Types.Exact<{
  skip?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type ShopByDepartmentSitemapQuery = (
  { __typename?: 'Query' }
  & { shopByDepartmentCollection?: Types.Maybe<(
    { __typename?: 'ShopByDepartmentCollection' }
    & Pick<Types.ShopByDepartmentCollection, 'total'>
    & { items: Array<Types.Maybe<(
      { __typename?: 'ShopByDepartment' }
      & Pick<Types.ShopByDepartment, 'slug'>
      & { sys: (
        { __typename?: 'Sys' }
        & Pick<Types.Sys, 'publishedAt'>
      ) }
    )>> }
  )> }
);


export const ShopByDepartmentItemFragmentDoc = `
    fragment shopByDepartmentItem on ShopByDepartment {
  title
  slug
  categoryLvl2Collection {
    items {
      hirearchy
      label
    }
  }
  thumbnail {
    url
    title
    width
    height
  }
}
    `;
export const ShopByDepartmentCollectionDocument = `
    query shopByDepartmentCollection {
  shopByDepartmentCollection(order: orderNumber_ASC) {
    items {
      ...shopByDepartmentItem
    }
  }
}
    ${ShopByDepartmentItemFragmentDoc}`;

export const useShopByDepartmentCollectionQuery = <
      TData = ShopByDepartmentCollectionQuery,
      TError = unknown
    >(
      variables?: ShopByDepartmentCollectionQueryVariables,
      options?: Omit<UseQueryOptions<ShopByDepartmentCollectionQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShopByDepartmentCollectionQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShopByDepartmentCollectionQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['shopByDepartmentCollection'] : ['shopByDepartmentCollection', variables],
    queryFn: graphqlFetcher<ShopByDepartmentCollectionQuery, ShopByDepartmentCollectionQueryVariables>(ShopByDepartmentCollectionDocument, variables),
    ...options
  }
    )};

useShopByDepartmentCollectionQuery.getKey = (variables?: ShopByDepartmentCollectionQueryVariables) => variables === undefined ? ['shopByDepartmentCollection'] : ['shopByDepartmentCollection', variables];


useShopByDepartmentCollectionQuery.fetcher = (variables?: ShopByDepartmentCollectionQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<ShopByDepartmentCollectionQuery, ShopByDepartmentCollectionQueryVariables>(ShopByDepartmentCollectionDocument, variables, options);

export const ShopByDepartmentSitemapDocument = `
    query shopByDepartmentSitemap($skip: Int, $limit: Int) {
  shopByDepartmentCollection(skip: $skip, limit: $limit) {
    total
    items {
      slug
      sys {
        publishedAt
      }
    }
  }
}
    `;

export const useShopByDepartmentSitemapQuery = <
      TData = ShopByDepartmentSitemapQuery,
      TError = unknown
    >(
      variables?: ShopByDepartmentSitemapQueryVariables,
      options?: Omit<UseQueryOptions<ShopByDepartmentSitemapQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<ShopByDepartmentSitemapQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<ShopByDepartmentSitemapQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['shopByDepartmentSitemap'] : ['shopByDepartmentSitemap', variables],
    queryFn: graphqlFetcher<ShopByDepartmentSitemapQuery, ShopByDepartmentSitemapQueryVariables>(ShopByDepartmentSitemapDocument, variables),
    ...options
  }
    )};

useShopByDepartmentSitemapQuery.getKey = (variables?: ShopByDepartmentSitemapQueryVariables) => variables === undefined ? ['shopByDepartmentSitemap'] : ['shopByDepartmentSitemap', variables];


useShopByDepartmentSitemapQuery.fetcher = (variables?: ShopByDepartmentSitemapQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<ShopByDepartmentSitemapQuery, ShopByDepartmentSitemapQueryVariables>(ShopByDepartmentSitemapDocument, variables, options);
